export const LAST_CLOSED_WORLD_MESSAGE = 'lastClosedWorldMessage';
export const SHOULD_USE_GUIDE_STEP_EDIT_V2 = 'use-guide-step-editor-v2';
